import ButtonBase from '@material-ui/core/ButtonBase';
import { Query } from 'react-apollo';

import ColumnSelectorDialog from '~/components/DynamicTable/ColumnSelectorDialog';
import { updateCompanyColumns, updatePersonColumns } from '~/lib/client';

import ColumnsIcon from './Columns.svg';
import query from './query.graphql';
import styles from './styles.styles';

class ColumnSelectorMenu extends React.Component {
  state = {
    isColumnSelectorDialogOpen: false,
  };

  attributesForColumnSelector = (allColumns = []) =>
    allColumns.map((column) => column.value);

  updateColumns = async (columns) => {
    const { updateColumns, onColumnsChanged } = this.props;

    if (columns) {
      await updateColumns(columns);
    }
    this.setState({ isColumnSelectorDialogOpen: false });

    onColumnsChanged && onColumnsChanged(columns);
  };

  render() {
    const { isColumnSelectorDialogOpen } = this.state;

    const { classes, segmentId, type } = this.props;

    const variables = {
      attributeType: type,
      columnType: type,
      ...(segmentId && { segmentId }),
    };

    return (
      <Query query={query} variables={variables}>
        {({ data = {}, loading, error }) => {
          if (loading || error) return null;

          const { columns, attributes } = data;
          return (
            <>
              <ButtonBase
                classes={{ root: classes.actionsButtonRoot }}
                onClick={() =>
                  this.setState({ isColumnSelectorDialogOpen: true })
                }>
                <ColumnsIcon />
              </ButtonBase>

              <ColumnSelectorDialog
                allColumns={this.attributesForColumnSelector(attributes)}
                columns={columns}
                onClose={this.updateColumns}
                open={isColumnSelectorDialogOpen}
              />
            </>
          );
        }}
      </Query>
    );
  }
}

ColumnSelectorMenu.propTypes = {
  onColumnsChanged: PropTypes.func.isRequired,
  updateColumns: PropTypes.func.isRequired,
};

const WrappedColumnSelectorMenu = (props) => {
  let updateColumns;

  if (props.type === 'Company') {
    updateColumns = (columns) =>
      updateCompanyColumns({
        columns,
        ...(props.segmentId && { segmentId: props.segmentId }),
      });
  }

  if (props.type === 'Person') {
    updateColumns = (columns) =>
      updatePersonColumns({
        columns,
        ...(props.segmentId && { segmentId: props.segmentId }),
      });
  }

  return <ColumnSelectorMenu updateColumns={updateColumns} {...props} />;
};

export default withStyles(styles)(WrappedColumnSelectorMenu);
